import React, { useState, useRef, useEffect } from 'react'
import Waveform from './Waveform'
import WaveformPlaceholder from './WaveformPlaceholder'

/**
 * Waveform wird erst geladen, wenn der Bereich sichtbar ist (IntersectionObserver).
 * Schnelleres initiales Laden bei vielen Tracks; nur sichtbare Waveforms laden Audio.
 */
export default function LazyWaveform({ audioUrl, height = 40, showControls = true, controlsPosition = 'bottom', waveColor, progressColor, className = '' }) {
  const [visible, setVisible] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true)
      },
      { rootMargin: '100px', threshold: 0.01 }
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  return (
    <div ref={containerRef} className={className} style={{ minHeight: height }}>
      {visible && audioUrl ? (
        <Waveform
          audioUrl={audioUrl}
          height={height}
          showControls={showControls}
          controlsPosition={controlsPosition}
          waveColor={waveColor}
          progressColor={progressColor}
          className="w-full"
        />
      ) : (
        <WaveformPlaceholder height={height} animate />
      )}
    </div>
  )
}
